import { forwardRef } from "react";
import type { CSSProperties, ReactNode, SVGProps } from "react";
import mapConfig from '../data/map-config.json';

interface MapArtworkProps extends SVGProps<SVGSVGElement> {
  onRouteClick?: (routeId: string) => void;
  onPortClick?: (portId: string) => void;
  routeStyles?: CSSProperties;
  portStyles?: CSSProperties;
  children?: ReactNode;
  gRef?: React.RefObject<SVGGElement | null>;
}
const SvgMapArtwork = forwardRef<SVGSVGElement, MapArtworkProps>(({
  onRouteClick,
  onPortClick,
  children,
  gRef,
  ...props
}, ref) => (
  <svg
    ref={ref}
    width={850}
    height={540}
    viewBox="0 0 850 540"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
      <g ref={gRef}>

    <rect width={850} height={540} fill="#F5F5F5" />
    <g id="vector map" clipPath="url(#clip0_0_1)">
      <rect width={850} height={540} fill="#E8E8E8" />
      <g id="Main_Islands">
        <g id="Naoshima">
          <path
            id="Vector 29"
            d="M182.143 228H177.537C177.185 228 176.84 228.093 176.535 228.269L168.896 232.692C168.082 233.163 167.048 233.003 166.415 232.306L163.095 228.655C162.716 228.238 162.179 228 161.615 228H158.5C157.395 228 156.5 228.895 156.5 230V234.672C156.5 235.202 156.711 235.711 157.086 236.086L158.914 237.914C159.289 238.289 159.5 238.798 159.5 239.328V245.81C159.5 246.257 159.65 246.691 159.925 247.043L168.075 257.457C168.35 257.809 168.5 258.243 168.5 258.69V266.463C168.5 266.815 168.593 267.16 168.769 267.465L173.422 275.502C173.78 276.12 174.439 276.5 175.153 276.5H178.57C179.16 276.5 179.719 276.76 180.099 277.211L183.956 281.789C184.336 282.24 184.895 282.5 185.485 282.5H190.672C191.202 282.5 191.711 282.711 192.086 283.086L196.459 287.459C197.447 288.447 199.116 288.144 199.694 286.873L200.467 285.172C200.792 284.458 201.504 284 202.288 284H206.172C206.702 284 207.211 284.211 207.586 284.586L209.414 286.414C209.789 286.789 210.298 287 210.828 287H213.952C214.311 287 214.663 286.903 214.972 286.721L227.02 279.581C227.627 279.221 228 278.567 228 277.86V270.152C228 268.686 226.475 267.718 225.148 268.342L219.905 270.81C219.638 270.935 219.347 271 219.053 271H214.5C213.395 271 212.5 270.105 212.5 269V261.883C212.5 261.32 212.263 260.784 211.848 260.405L185.143 236.036C184.765 235.692 184.534 235.216 184.496 234.707L184.137 229.852C184.06 228.808 183.19 228 182.143 228Z"
            fill="#828282"
          />
        </g>
        <g id="Teshima">
          <path
            id="Vector 34"
            d="M283 225.5V225.669C283 226.793 283.628 227.823 284.628 228.337L299.854 236.168C300.279 236.386 300.749 236.5 301.226 236.5H314.714C315.535 236.5 316.32 236.836 316.887 237.431L335.113 256.569C335.68 257.164 336.465 257.5 337.286 257.5H342.606C343.763 257.5 344.817 256.835 345.314 255.79L354.247 237.031C354.414 236.68 354.648 236.365 354.935 236.104L370.521 221.892C371.145 221.324 371.5 220.519 371.5 219.676V207.478C371.5 206.278 370.785 205.193 369.682 204.721L365.066 202.743C364.693 202.583 364.291 202.5 363.884 202.5H354.763C353.423 202.5 352.246 201.612 351.878 200.324L348.122 187.176C347.754 185.888 346.577 185 345.237 185H333.908C333.316 185 332.737 185.175 332.244 185.504L330.756 186.496C330.263 186.825 329.684 187 329.092 187H322.132C321.114 187 320.166 187.516 319.613 188.37L315.887 194.13C315.334 194.984 314.386 195.5 313.368 195.5H311.5C309.843 195.5 308.5 196.843 308.5 198.5V199.333C308.5 200.084 308.219 200.807 307.711 201.36L303.892 205.527C303.324 206.147 302.521 206.5 301.68 206.5H290.277C289.768 206.5 289.266 206.37 288.82 206.122L281.13 201.85C280.717 201.62 280.252 201.5 279.78 201.5C278.245 201.5 277 202.745 277 204.28V209.456C277 210.425 276.532 211.334 275.744 211.897L274.282 212.941C273.774 213.305 273.164 213.5 272.539 213.5H271.5C269.843 213.5 268.5 214.843 268.5 216.5V217.373C268.5 218.099 268.764 218.801 269.242 219.348L271.104 221.476C271.673 222.127 272.496 222.5 273.361 222.5H280C281.657 222.5 283 223.843 283 225.5Z"
            fill="#828282"
          />
        </g>
        <g id="Megijima">
          <path
            id="Vector 35"
            d="M260.552 406.061L265.818 361.539C265.932 360.574 266.507 359.723 267.361 359.258L269.992 357.822C270.926 357.313 272.06 357.336 272.973 357.884L275.043 359.126C275.947 359.668 276.5 360.645 276.5 361.699V366.013C276.5 366.336 276.552 366.656 276.654 366.962L277.846 370.538C277.948 370.844 278 371.164 278 371.487V388C278 388.649 277.789 389.281 277.4 389.8L274.014 394.314C273.678 394.762 273.474 395.296 273.426 395.854L272.54 406.042C272.513 406.346 272.441 406.643 272.325 406.925L269.765 413.142C269.302 414.266 268.207 415 266.991 415H264.517C263.061 415 261.816 413.955 261.563 412.521L260.577 406.935C260.526 406.647 260.517 406.352 260.552 406.061Z"
            fill="#828282"
          />
        </g>
        <g id="Ogijima">
          <path
            id="Vector 36"
            d="M311.712 314.481L315.906 312.683C316.892 312.261 318.029 312.397 318.888 313.041L320.538 314.279C321.156 314.742 321.571 315.425 321.698 316.186L322.89 323.341C322.963 323.775 322.939 324.22 322.82 324.643L320.114 334.309C319.751 335.604 318.57 336.5 317.225 336.5H314.56C313.319 336.5 312.206 337.264 311.76 338.423L310.658 341.289C310.262 342.32 309.271 343 308.166 343C306.904 343 305.814 342.116 305.554 340.88L304.173 334.321C304.06 333.784 304.096 333.226 304.278 332.708L310.063 316.244C310.341 315.451 310.94 314.812 311.712 314.481Z"
            fill="#828282"
          />
        </g>
        <g id="Oshima">
          <path
            id="Vector 37"
            d="M382.921 350.6L381.715 349.596C381.253 349.211 380.671 349 380.07 349C378.65 349 377.5 350.15 377.5 351.57V352.534C377.5 352.843 377.548 353.15 377.641 353.444L380.545 362.569C380.831 363.47 380.677 364.453 380.127 365.222L379.397 366.244C378.834 367.032 377.925 367.5 376.956 367.5H375.743C374.947 367.5 374.184 367.816 373.621 368.379L372.879 369.121C372.316 369.684 372 370.447 372 371.243V373C372 374.657 373.343 376 375 376H382.901C383.611 376 384.297 375.748 384.839 375.29L389.438 371.399C390.111 370.829 390.5 369.991 390.5 369.109V367.928C390.5 367.323 390.317 366.733 389.976 366.234L384.524 358.266C384.183 357.767 384 357.177 384 356.572V352.905C384 352.015 383.605 351.17 382.921 350.6Z"
            fill="#828282"
          />
        </g>
        <g id="Inujima">
          <path
            id="Vector 38"
            d="M356.39 129.5H354.509C353.293 129.5 352.198 128.766 351.735 127.642L349.761 122.849C349.3 121.729 349.558 120.442 350.414 119.586L354.187 115.813C354.708 115.292 355.414 115 356.15 115H357.169C358.562 115 359.545 113.635 359.105 112.314C359.035 112.106 359 111.888 359 111.669V109C359 107.343 360.343 106 362 106H365.095C365.985 106 366.83 106.395 367.4 107.079L367.72 107.464C369.291 109.349 372.337 108.652 372.932 106.271L372.98 106.08C373.286 104.858 374.384 104 375.644 104C376.999 104 378.152 104.989 378.358 106.329L379.921 116.49C379.973 116.827 379.967 117.172 379.903 117.507L378.465 125.061C378.195 126.476 376.958 127.5 375.517 127.5H371.647C370.621 127.5 369.667 126.976 369.116 126.111L368.334 124.882C367.491 123.558 365.55 123.583 364.743 124.929L364.669 125.052C364.05 126.083 362.665 126.332 361.726 125.581C360.426 124.541 358.5 125.466 358.5 127.131V127.39C358.5 128.555 357.555 129.5 356.39 129.5Z"
            fill="#828282"
          />
        </g>
        <g id="Shodoshima">
          <path
            id="Vector 43"
            d="M492 159.5H500.719C501.817 159.5 502.827 158.9 503.353 157.937L504.935 155.036C505.298 154.37 505.9 153.867 506.62 153.627L513.396 151.368C514.106 151.131 514.879 151.169 515.563 151.473L517.887 152.505C518.601 152.823 519.41 152.849 520.143 152.579L537.083 146.338C537.679 146.118 538.19 145.715 538.542 145.187L542.109 139.836C542.666 139.001 543.602 138.5 544.606 138.5H549.5C550.149 138.5 550.781 138.711 551.3 139.1L554.988 141.866C555.912 142.559 557.152 142.66 558.176 142.126L566.62 137.72C567.485 137.269 568.077 136.424 568.206 135.457L568.8 130.998C568.926 130.056 569.491 129.229 570.323 128.769L586.768 119.681C587.548 119.25 588.097 118.493 588.263 117.617L589.535 110.939C589.805 109.524 591.042 108.5 592.483 108.5H593.386C594.654 108.5 595.785 107.703 596.211 106.509L597.289 103.491C597.715 102.297 598.846 101.5 600.114 101.5H601C602.657 101.5 604 102.843 604 104.5V105.5C604 107.157 605.343 108.5 607 108.5H611.693C611.897 108.5 612.101 108.521 612.301 108.562L626.199 111.438C626.399 111.479 626.603 111.5 626.807 111.5H639.729C640.542 111.5 641.319 111.171 641.884 110.587L656.028 95.9876C656.339 95.6666 656.717 95.4191 657.136 95.2633L677.776 87.5833C677.925 87.5278 678.078 87.4843 678.234 87.4532L695.209 84.0583C695.402 84.0195 695.6 84 695.797 84H704.332C705.07 84 705.768 84.3356 706.23 84.912C706.965 85.831 706.936 87.1447 706.161 88.0304L704.74 89.6539C704.27 90.1916 703.59 90.5 702.876 90.5C700.95 90.5 699.761 92.6009 700.751 94.2522L701.653 95.7545C702.425 97.0409 704.028 97.5594 705.407 96.9685L709.544 95.1955C709.846 95.0661 710.125 94.8878 710.369 94.668L714.144 91.2701C714.695 90.7743 715.41 90.5 716.151 90.5H719C720.657 90.5 722 91.8431 722 93.5C722 95.1569 720.657 96.5 719 96.5H715.741C715.254 96.5 714.775 96.6185 714.344 96.8452L706.463 100.993C705.841 101.321 705.353 101.856 705.086 102.506L702.492 108.806C702.178 109.568 701.564 110.168 700.795 110.464L697.02 111.915C696.104 112.268 695.5 113.147 695.5 114.128C695.5 114.691 695.7 115.235 696.064 115.664L703.102 123.943C703.672 124.614 704.507 125 705.387 125H710.192C711.026 125 711.823 125.347 712.39 125.959L717.198 131.137C717.714 131.692 718 132.421 718 133.178V136.563C718 137.173 717.814 137.769 717.467 138.271L714.033 143.229C713.686 143.731 713.5 144.327 713.5 144.937V159.071C713.5 159.356 713.46 159.639 713.38 159.911L710.343 170.325C710.123 171.078 709.617 171.715 708.933 172.1L703.529 175.14C702.585 175.671 702 176.671 702 177.755V180.5C702 181.444 702.445 182.333 703.2 182.9L705.048 184.286C705.66 184.745 706.073 185.419 706.204 186.172L707.389 192.986C707.708 194.821 706.296 196.5 704.433 196.5H701.004C699.554 196.5 698.311 197.537 698.052 198.963L697.548 201.734C697.516 201.911 697.5 202.091 697.5 202.271V207.2C697.5 208.03 697.843 208.822 698.448 209.389L704.635 215.189C705.191 215.71 705.924 216 706.686 216H707C708.657 216 710 217.343 710 219V219.592C710 220.184 709.825 220.763 709.496 221.256L708.028 223.457C707.398 224.403 707.356 225.623 707.92 226.61L708.003 226.756C708.606 227.811 708.513 229.126 707.767 230.086L706.132 232.188C705.722 232.714 705.5 233.362 705.5 234.029V237.723C705.5 238.232 705.37 238.734 705.122 239.18L696.357 254.957C695.828 255.909 694.824 256.5 693.735 256.5H693C691.343 256.5 690 257.843 690 259.5V270.554C690 271.17 690.189 271.77 690.542 272.275L692.681 275.329C693.199 276.07 693.356 277.005 693.107 277.874L692.122 281.324C691.754 282.612 690.577 283.5 689.237 283.5H688.656C687.625 283.5 686.667 282.971 686.118 282.098L679.536 271.645C678.906 270.644 678.929 269.357 679.585 268.373C680.152 267.522 680.252 266.434 679.843 265.498L677.406 259.928C677.143 259.326 676.689 258.827 676.114 258.508L673.311 256.951C672.783 256.657 672.355 256.211 672.085 255.67L668.829 249.158C668.321 248.142 667.282 247.5 666.146 247.5H664.6C664.204 247.5 663.812 247.578 663.446 247.731L658.554 249.769C658.188 249.922 657.796 250 657.4 250H650.86C650.298 250 649.747 249.842 649.27 249.544L647.842 248.651C646.743 247.964 645.327 248.061 644.331 248.891L643.719 249.401C643.251 249.791 642.913 250.315 642.749 250.902L641.11 256.803C640.75 258.101 639.567 259 638.22 259H638.176C637.135 259 636.167 259.54 635.621 260.428L633.379 264.072C632.833 264.96 631.865 265.5 630.824 265.5H628.354C627.218 265.5 626.179 266.142 625.671 267.158L625.267 267.967C624.379 269.742 622.043 270.181 620.571 268.85L615.841 264.57C614.612 263.458 615.097 261.428 616.696 260.992L617.023 260.903C617.865 260.673 618.745 261.111 619.068 261.921C619.329 262.573 619.96 263 620.662 263H622.5C624.157 263 625.5 261.657 625.5 260V255.686C625.5 254.924 625.21 254.191 624.689 253.635L622.811 251.631C622.29 251.075 622 250.341 622 249.579V246.141C622 244.86 622.813 243.72 624.025 243.304L636.571 238.991C637.47 238.682 638.462 238.818 639.245 239.356L643.944 242.586C645.135 243.406 646.742 243.258 647.765 242.235L649.121 240.879C649.684 240.316 650.447 240 651.243 240H657.092C657.684 240 658.263 240.175 658.756 240.504L659.191 240.794C660.849 241.899 663.105 241.11 663.712 239.212L665.915 232.329C666.272 231.214 665.947 229.994 665.085 229.203L661.095 225.546C660.705 225.188 660.417 224.734 660.259 224.229L658.658 219.105C658.266 217.853 657.107 217 655.794 217H650.127C649.401 217 648.699 217.264 648.152 217.742L645.848 219.758C645.301 220.236 644.599 220.5 643.873 220.5H643.5C641.843 220.5 640.5 219.157 640.5 217.5C640.5 215.843 639.157 214.5 637.5 214.5C635.843 214.5 634.5 215.843 634.5 217.5V217.862C634.5 218.883 633.981 219.834 633.122 220.386L628.241 223.524C627.757 223.835 627.194 224 626.619 224H623.478C622.278 224 621.193 224.715 620.721 225.818L619.279 229.182C618.807 230.285 617.722 231 616.522 231H604.541C603.075 231 601.823 232.06 601.582 233.507L600.627 239.239C600.544 239.738 600.336 240.208 600.022 240.605L593.087 249.389C592.416 250.239 592.255 251.386 592.667 252.388L595.226 258.617C595.693 259.754 595.42 261.061 594.537 261.915L582.407 273.64C581.598 274.422 581.484 275.677 582.137 276.592C582.883 277.636 582.616 279.089 581.549 279.801L577.336 282.609C576.501 283.166 576 284.102 576 285.106V291.589C576 292.755 576.675 293.815 577.731 294.308L579.168 294.979C581.173 295.914 581.51 298.623 579.796 300.022L565.328 311.825C564.792 312.261 564.123 312.5 563.432 312.5H560.16C559.414 312.5 558.694 312.222 558.142 311.72L554.482 308.393C553.857 307.824 553.5 307.018 553.5 306.173V303.836C553.5 302.986 553.139 302.175 552.507 301.606L549.961 299.314C549.074 298.516 548.744 297.268 549.121 296.136L549.316 295.551C549.725 294.326 550.871 293.5 552.162 293.5H554.735C555.237 293.5 555.731 293.374 556.172 293.134L564.937 288.353C565.9 287.827 566.5 286.817 566.5 285.719V280.408C566.5 279.816 566.325 279.237 565.996 278.744L565.129 277.444C564.224 276.086 562.399 275.701 561.022 276.577L558.737 278.031C558.256 278.337 557.697 278.5 557.126 278.5H550.5C548.843 278.5 547.5 277.134 547.5 275.477C547.5 274.285 548.206 273.191 549.298 272.714L560.076 268.002C560.81 267.681 561.385 267.079 561.673 266.332L564.299 259.521C564.432 259.177 564.5 258.811 564.5 258.442V252.667C564.5 251.916 564.781 251.193 565.289 250.64L569.028 246.561C569.642 245.89 569.92 244.977 569.781 244.078L569.236 240.533C569.088 239.572 568.483 238.741 567.612 238.306L566.27 237.635C565.111 237.055 564.795 235.546 565.625 234.55C566.153 233.916 566.241 233.024 565.846 232.3L564.353 229.563C563.827 228.6 562.817 228 561.719 228H561.29C560.772 228 560.263 228.134 559.813 228.389L558.21 229.295C557.438 229.732 556.493 229.728 555.724 229.284C554.505 228.58 554.105 227.01 554.839 225.808L557.89 220.816C558.555 219.729 558.459 218.339 557.652 217.352L555.4 214.6C554.83 213.904 553.978 213.5 553.078 213.5H548.486C547.845 213.5 547.222 213.705 546.706 214.085L540.461 218.687C539.109 219.683 537.204 219.376 536.233 218.006L530.397 209.766C529.834 208.972 528.922 208.5 527.949 208.5H524.641C523.906 208.5 523.197 208.77 522.648 209.258L521.217 210.529C519.989 211.621 518.11 211.521 517.004 210.305L515.673 208.841C514.703 207.773 513.11 207.548 511.881 208.304L495.223 218.555C494.75 218.846 494.206 219 493.651 219H490.778C489.681 219 488.673 219.598 488.146 220.559L477.951 239.177C477.657 239.713 477.207 240.146 476.661 240.42L465.133 246.183C464.717 246.392 464.258 246.5 463.792 246.5H457.911C457.017 246.5 456.17 246.101 455.6 245.413L445.574 233.298C444.907 232.492 444.708 231.396 445.049 230.407L453.803 205.022C454.22 203.812 455.359 203 456.639 203H468.736C469.076 203 469.414 203.058 469.735 203.171L472.326 204.086C473.078 204.351 473.904 204.306 474.623 203.961L476.01 203.295C476.415 203.101 476.858 203 477.308 203H483.456C483.816 203 484.173 203.065 484.509 203.191L486.23 203.836C488.572 204.715 490.898 202.509 490.144 200.124L486.662 189.097C486.268 187.849 485.11 187 483.801 187H482.911C481.745 187 480.685 186.325 480.192 185.269L475.148 174.46C474.496 173.063 472.893 172.388 471.438 172.897L466.516 174.619C465.286 175.05 464 174.137 464 172.834C464 172.303 464.224 171.796 464.616 171.438L474.128 162.753C474.968 161.985 475.302 160.808 474.99 159.713L472.925 152.489C472.659 151.555 472.861 150.549 473.467 149.791L476.081 146.524C477.306 144.993 479.647 145.029 480.823 146.598L489.6 158.3C490.167 159.055 491.056 159.5 492 159.5Z"
            fill="#828282"
          />
        </g>
      </g>
      <g id="Okayama">
        <path
          id="Vector 46"
          d="M316.357 24.6498L316.064 18.7757C316.023 17.9607 316.316 17.1641 316.875 16.5698L322.949 10.1171C323.609 9.41558 324.566 9.07381 325.521 9.19842L334.192 10.3294C335.026 10.4381 335.866 10.1923 336.51 9.65174L347.163 0.702886C347.704 0.248887 348.387 0 349.093 0H409.701C411.057 0 412.245 0.910235 412.598 2.22008L418.685 24.8305C418.887 25.5808 419.372 26.2234 420.039 26.6231L422.543 28.1261C423.447 28.6683 424 29.6448 424 30.6986V31.921C424 33.1715 424.776 34.2909 425.947 34.73L426.379 34.8921C427.382 35.2683 428.108 36.151 428.285 37.2079L428.437 38.1203C428.732 39.8895 427.367 41.5 425.574 41.5C424.881 41.5 424.211 41.7479 423.685 42.1988L422.293 43.392C421.593 43.9919 420.532 43.8754 419.979 43.138C419.677 42.7364 419.205 42.5 418.702 42.5H412.603C411.891 42.5 411.202 42.7531 410.66 43.2142L402.919 49.7936C402.05 50.5325 401.675 51.7003 401.952 52.8071L402.088 53.3521C402.344 54.3745 402.044 55.4559 401.299 56.2011L400.379 57.1213C399.816 57.6839 399.053 58 398.257 58H386.708C386.242 58 385.783 57.8916 385.367 57.6833L381.633 55.8167C381.217 55.6084 380.758 55.5 380.292 55.5H375.18C374.422 55.5 373.691 55.7874 373.136 56.3043L360.364 68.1957C359.809 68.7126 359.078 69 358.32 69H347.806C346.695 69 345.675 68.3858 345.155 67.4037L342.345 62.0963C341.825 61.1142 340.805 60.5 339.694 60.5H332.797C332.275 60.5 331.762 60.6362 331.308 60.8953L329.192 62.1047C328.738 62.3638 328.225 62.5 327.703 62.5H324.331C323.787 62.5 323.254 62.3522 322.787 62.0725L314.957 57.3739C314.053 56.8317 313.5 55.8552 313.5 54.8014V43.2859C313.5 42.7706 313.633 42.2641 313.885 41.8151L317.14 36.0292C317.671 35.0846 318.671 34.5 319.755 34.5H322.757C323.553 34.5 324.316 34.1839 324.879 33.6213L325.16 33.3398C326.216 32.2841 326.335 30.6129 325.439 29.4185L324.9 28.7C324.333 27.9446 323.444 27.5 322.5 27.5H319.354C317.755 27.5 316.437 26.2464 316.357 24.6498Z"
          fill="#B8B8B8"
        />
        <path
          id="Vector 47"
          d="M3.61603 234.402L2.66871 234.297C1.14941 234.128 0 232.844 0 231.315V3C0 1.34315 1.34315 0 3.00001 0H141.399C142.4 0 143.334 0.498875 143.891 1.33015L174.309 46.7291C175.411 48.3749 174.644 50.6186 172.765 51.245L161.813 54.8958C160.707 55.2644 159.488 54.9592 158.686 54.113L153.12 48.2375C151.958 47.0117 150.015 46.9854 148.821 48.1794L146.715 50.2854C146.262 50.7382 145.631 50.9665 144.994 50.9085C143.188 50.7443 141.997 52.7456 143.003 54.2543L144.731 56.8457C145.219 57.578 145.361 58.4877 145.119 59.3339L145.091 59.4329C144.738 60.6687 145.211 61.9921 146.268 62.7237L161.788 73.4683C163.047 74.3398 164.76 74.1236 165.762 72.9666L169.78 68.3306C170.245 67.7943 170.885 67.4401 171.586 67.3311L191.896 64.1717C192.608 64.061 193.336 64.2102 193.947 64.5921L195.627 65.642C196.404 66.1272 197.422 65.9373 197.971 65.205C198.304 64.7612 198.827 64.5 199.381 64.5H203.895C204.898 64.5 205.834 65.0013 206.391 65.8359L206.609 66.1641C207.166 66.9987 208.103 67.5 209.106 67.5H215.063C215.353 67.5 215.641 67.4579 215.919 67.3752L238.581 60.6248C238.859 60.5421 239.147 60.5 239.437 60.5H259.5C261.157 60.5 262.5 61.8431 262.5 63.5V64.7574C262.5 65.553 262.816 66.3161 263.379 66.8787L265.621 69.1213C266.184 69.6839 266.947 70 267.743 70H269.225C270.57 70 271.751 70.8956 272.114 72.1911L274.642 81.22C274.87 82.0351 275.432 82.7159 276.189 83.0944L283.317 86.6584C283.736 86.8677 284 87.2957 284 87.7639C284 88.4466 283.447 89 282.764 89H274.106C273.103 89 272.166 89.5013 271.609 90.3359L271.023 91.2159C270.161 92.5088 268.454 92.9296 267.09 92.1855L266.456 91.8394C265.073 91.085 263.342 91.529 262.492 92.8559L257.445 100.742C256.664 101.963 257.081 103.59 258.354 104.284L258.667 104.455C260.042 105.204 260.25 107.094 259.071 108.125C258.185 108.901 258.046 110.228 258.753 111.17L258.841 111.289C259.719 112.458 259.361 114.133 258.084 114.842L257.526 115.152C256.584 115.675 256 116.668 256 117.746V118.068C256 119.245 256.688 120.313 257.759 120.799L259.325 121.511C260.42 122.009 260.74 123.412 259.971 124.335C259.408 125.01 258.444 125.187 257.679 124.757L253.252 122.267C251.958 121.539 250.325 121.867 249.414 123.04L244.943 128.788C244.367 129.528 244.267 130.534 244.687 131.374C245.369 132.738 244.644 134.387 243.177 134.807L241.171 135.38C239.886 135.747 238.512 135.219 237.803 134.085L236.956 132.73C236.658 132.253 236.5 131.702 236.5 131.14V127C236.5 125.343 235.157 124 233.5 124H227.967C227.042 124 226.168 124.427 225.599 125.158L220.401 131.842C219.833 132.573 218.959 133 218.033 133H212.892C212.633 133 212.375 132.955 212.131 132.868L206.205 130.752C204.832 130.261 203.841 132.084 204.999 132.97C205.83 133.605 205.587 134.916 204.584 135.211L202.129 135.933C200.386 136.445 199.707 138.552 200.822 139.985L201.368 140.688C201.778 141.214 202 141.862 202 142.529V143.818C202 144.577 202.288 145.309 202.807 145.864L208.111 151.547C208.678 152.155 209.472 152.5 210.304 152.5H215.705C216.696 152.5 217.5 153.304 217.5 154.295C217.5 154.748 217.329 155.185 217.02 155.517L213.298 159.526C212.075 160.842 209.977 160.796 208.813 159.427L203.399 153.057C202.829 152.386 201.993 152 201.113 152H198.896C197.738 152 196.683 151.333 196.186 150.287L188.314 133.713C187.817 132.667 186.762 132 185.604 132H183.05C182.686 132 182.326 132.066 181.986 132.195L154.102 142.772C153.705 142.922 153.345 143.155 153.045 143.455L148.82 147.68C147.773 148.727 147.646 150.381 148.522 151.575L149.738 153.234C150.885 154.797 149.769 157 147.83 157C147.293 157 146.771 157.183 146.352 157.519L145.626 158.099C144.914 158.669 144.5 159.531 144.5 160.442V160.794C144.5 162.107 145.353 163.266 146.605 163.658L148.606 164.283C150.538 164.887 151.33 167.19 150.178 168.854L148.199 171.712C148.067 171.903 147.913 172.079 147.74 172.234L145.095 174.614C143.918 175.674 143.767 177.467 144.752 178.708L152.771 188.819C153.746 190.049 153.608 191.823 152.455 192.888L149.779 195.358C148.743 196.315 147.178 196.413 146.031 195.593C145.096 194.926 143.86 194.856 142.856 195.413L140.68 196.622C140.234 196.87 139.733 197 139.223 197H124.765C123.676 197 122.672 197.591 122.143 198.543L120.949 200.692C120.656 201.218 120.529 201.821 120.584 202.421L120.847 205.312C120.942 206.359 120.481 207.38 119.633 208.003L115.147 211.292C114.153 212.021 113.706 213.283 114.02 214.475L115.258 219.181C115.671 220.751 114.761 222.364 113.203 222.823L110.607 223.586C108.931 224.079 108.029 225.895 108.649 227.528L116.959 249.436C117.703 251.399 116.253 253.5 114.154 253.5H110.647C109.621 253.5 108.667 254.024 108.116 254.889L107.447 255.941C106.436 257.529 104.23 257.805 102.86 256.515L98.5728 252.48C97.6966 251.656 96.3237 251.676 95.4729 252.527C94.8767 253.123 94.6685 254.005 94.9351 254.805L95.6838 257.051C96.3314 258.994 94.8855 261 92.8378 261H82.4202C82.1415 261 81.8641 260.961 81.5961 260.885L75.4041 259.115C75.136 259.039 74.8586 259 74.5799 259H69.4234C68.8218 259 68.234 258.819 67.7365 258.481L56.7636 251.019C56.2661 250.681 55.6783 250.5 55.0767 250.5H25.0733C24.3793 250.5 23.7068 250.259 23.1704 249.819L5.18769 235.064C4.73893 234.696 4.19297 234.466 3.61603 234.402Z"
          fill="#B8B8B8"
        />
        <path
          id="Vector 48"
          d="M182.607 44.1892L155.695 4.68917C154.338 2.69766 155.764 0 158.174 0H184.226C185.32 0 186.328 0.595599 186.855 1.55424L201.894 28.8974C202.281 29.6027 202.37 30.4343 202.138 31.2052L199.804 38.9883C199.607 39.6431 199.193 40.2111 198.63 40.5984L192.268 44.9721C191.768 45.3159 191.175 45.5 190.568 45.5H185.086C184.094 45.5 183.166 45.0093 182.607 44.1892Z"
          fill="#B8B8B8"
        />
        <path
          id="Vector 49"
          d="M212.776 28.4053L197.077 4.65429C195.758 2.65987 197.188 0 199.579 0H266.698C268.056 0 269.244 0.912118 269.595 2.22379L276.228 26.9845C276.404 27.6419 276.351 28.3396 276.078 28.9632L273.579 34.6761C273.213 35.5127 272.486 36.1371 271.604 36.3723L266.122 37.8342C265.712 37.9435 265.283 37.9646 264.865 37.8962L214.795 29.7117C213.969 29.5767 213.237 29.1032 212.776 28.4053Z"
          fill="#B8B8B8"
        />
        <path
          id="Vector 50"
          d="M285.672 22.8001L277 4.27182C276.068 2.28259 277.52 0 279.717 0H302.68C304.046 0 305.24 0.922948 305.584 2.2451L311.029 23.1867C311.317 24.2962 310.948 25.4732 310.077 26.2193L309.556 26.6663C308.618 27.4706 307.282 27.6172 306.192 27.0356L302.496 25.0643C301.469 24.5167 300.198 25.0557 299.879 26.1747C299.655 26.9592 298.938 27.5 298.122 27.5H292.476C291.842 27.5 291.224 27.2991 290.711 26.9262L286.625 23.9545C286.215 23.6564 285.887 23.2592 285.672 22.8001Z"
          fill="#B8B8B8"
        />
      </g>
      <g id="Kagawa">
        <path
          id="Vector 45"
          d="M19.4027 439.776L1.26761 452.603C0.472616 453.166 0 454.079 0 455.053V537.5C0 539.157 1.34314 540.5 2.99999 540.5H583.592C586.047 540.5 587.463 537.712 586.014 535.73L581.98 530.21C580.924 528.765 581.36 526.723 582.914 525.835L592.248 520.501C593.307 519.896 593.895 518.709 593.733 517.5L593.34 514.549C593.144 513.082 594.047 511.692 595.467 511.274L598.422 510.405C600.088 509.915 600.991 508.119 600.391 506.49L598.995 502.7C598.439 501.191 599.171 499.512 600.656 498.893L602.154 498.269C603.272 497.803 604 496.711 604 495.5C604 493.843 602.657 492.5 601 492.5H598.442C597.531 492.5 596.669 492.086 596.099 491.374L593.657 488.322C593.232 487.79 593 487.129 593 486.448V479.103C593 478.391 592.747 477.702 592.286 477.16L586.683 470.568C585.521 469.201 583.426 469.153 582.202 470.466L565.865 487.999C564.808 489.133 563.062 489.275 561.836 488.327L554.166 482.401C553.43 481.833 553 480.956 553 480.027V479.311C553 478.197 552.383 477.175 551.397 476.656L545.103 473.344C544.117 472.825 543.5 471.803 543.5 470.689V464.824C543.5 464.609 543.477 464.394 543.431 464.183L540.147 449.172C540.05 448.73 539.855 448.315 539.575 447.959L535.401 442.647C534.832 441.923 533.962 441.5 533.042 441.5H528.5C526.843 441.5 525.5 442.843 525.5 444.5V447.821C525.5 448.268 525.6 448.709 525.793 449.113L535.146 468.71C535.664 469.795 535.484 471.085 534.688 471.987L529.396 477.985C528.826 478.63 528.007 479 527.146 479H512C510.343 479 509 477.657 509 476V473C509 472.056 508.555 471.167 507.8 470.6L503.8 467.6C503.281 467.211 502.649 467 502 467C500.343 467 499 468.343 499 470V473.284C499 474.601 499.859 475.764 501.118 476.152L503.382 476.848C504.641 477.236 505.5 478.399 505.5 479.716V484.75C505.5 485.716 504.716 486.5 503.75 486.5C502.784 486.5 502 487.284 502 488.25V493.5C502 495.157 500.657 496.5 499 496.5H497C495.343 496.5 494 497.843 494 499.5V503.394C494 504.398 493.499 505.334 492.664 505.891L487.996 509.003C487.075 509.617 485.891 509.674 484.915 509.151L473.164 502.856C472.728 502.622 472.241 502.5 471.747 502.5H468.771C467.958 502.5 467.181 502.171 466.616 501.587L452.845 487.373C452.303 486.813 452 486.064 452 485.285V476.331C452 475.787 452.148 475.254 452.428 474.787L457.572 466.213C457.852 465.746 458 465.213 458 464.669V449.325C458 448.785 458.146 448.255 458.421 447.791L468.579 430.709C468.854 430.245 469 429.715 469 429.175V419.349C469 418.794 468.846 418.25 468.555 417.777L461.384 406.124C461.132 405.714 460.785 405.371 460.372 405.123L425.16 383.996C424.149 383.39 422.877 383.431 421.909 384.102L412.034 390.938C411.095 391.588 409.868 391.649 408.869 391.094L404.157 388.476C402.695 387.664 400.852 388.204 400.059 389.676L399.058 391.535C398.43 392.701 398.642 394.142 399.578 395.078L400.621 396.121C401.184 396.684 401.5 397.447 401.5 398.243V401.172C401.5 402.734 402.766 404 404.328 404C405.079 404 405.798 403.702 406.328 403.172L407.536 401.964C408.644 400.856 410.419 400.788 411.609 401.808L411.952 402.102C412.617 402.672 413 403.504 413 404.38V409.918C413 410.751 412.441 411.48 411.636 411.696L411.476 411.739C410.881 411.898 410.248 411.697 409.853 411.224C409.053 410.263 407.507 410.569 407.132 411.762L403.16 424.399C402.767 425.65 401.609 426.5 400.298 426.5H397.5C395.843 426.5 394.5 427.843 394.5 429.5V429.849C394.5 430.59 394.774 431.305 395.27 431.856L398.23 435.144C398.726 435.695 399 436.41 399 437.151V439C399 440.657 397.657 442 396 442H389C387.343 442 386 440.657 386 439V433.191C386 432.426 385.708 431.69 385.183 431.133L361.931 406.457C361.647 406.156 361.428 405.799 361.289 405.409L359.348 399.973C359.139 399.39 358.586 399 357.967 399C357.157 399 356.5 399.657 356.5 400.467V434.363C356.5 434.783 356.412 435.198 356.241 435.582L344.644 461.677C344.548 461.892 344.428 462.094 344.285 462.281L338.402 469.975C338.149 470.306 337.755 470.5 337.339 470.5C336.599 470.5 336 469.901 336 469.161V449.5C336 448.672 335.328 448 334.5 448C333.672 448 333 447.328 333 446.5V445.25C333 444.284 332.216 443.5 331.25 443.5C330.284 443.5 329.5 444.284 329.5 445.25V461C329.5 462.657 328.157 464 326.5 464H324.5C322.843 464 321.5 462.657 321.5 461V440.5C321.5 438.843 320.157 437.5 318.5 437.5H315C313.343 437.5 312 438.843 312 440.5V448.158C312 449.534 311.063 450.734 309.728 451.068L306.171 451.957C304.895 452.276 304 453.423 304 454.737V454.815C304 455.986 304.739 457.028 305.843 457.416C307.094 457.855 307.855 459.122 307.655 460.432L306.889 465.453C306.665 466.918 305.405 468 303.923 468H281.5C279.843 468 278.5 466.657 278.5 465V459.163C278.5 458.128 277.967 457.167 277.09 456.619L275.731 455.77C274.954 455.284 273.996 455.18 273.132 455.488L268.863 457.013C268.045 457.305 267.5 458.079 267.5 458.947C267.5 460.081 266.581 461 265.447 461H253.042C252.684 461 252.328 460.936 251.992 460.81L221.055 449.255C219.41 448.64 217.592 449.563 217.117 451.252L216.115 454.812C215.751 456.106 214.571 457 213.228 457H206.079C205.381 457 204.706 456.757 204.168 456.313L194.589 448.4C193.899 447.83 193.5 446.982 193.5 446.087V444.606C193.5 443.602 192.999 442.666 192.164 442.109L181.336 434.891C180.501 434.334 180 433.398 180 432.394V428.552C180 427.871 179.768 427.21 179.343 426.678L176.901 423.626C176.331 422.914 175.469 422.5 174.558 422.5H171.743C170.947 422.5 170.184 422.816 169.621 423.379L159.879 433.121C159.316 433.684 159 434.447 159 435.243V440.202C159 440.919 158.419 441.5 157.702 441.5C157.264 441.5 156.856 441.279 156.616 440.912L149.781 430.46C149.072 429.375 149.369 427.92 150.448 427.201C151.105 426.763 151.5 426.026 151.5 425.236V417.548C151.5 416.313 150.743 415.204 149.593 414.754L131.192 407.553C129.689 406.965 127.991 407.671 127.347 409.151L124.284 416.196C123.808 417.292 122.727 418 121.533 418H118C116.343 418 115 416.657 115 415V407.199C115 406.145 114.447 405.168 113.543 404.626L108.124 401.375C107.714 401.128 107.369 400.788 107.117 400.381L101.753 391.717C101.285 390.96 100.459 390.5 99.5689 390.5C98.1502 390.5 97 391.65 97 393.069V395.077C97 395.678 96.8191 396.266 96.4808 396.764L89.0192 407.736C88.6809 408.234 88.5 408.822 88.5 409.423V411C88.5 412.657 87.1569 414 85.5 414H79.6462C78.9081 414 78.1959 413.728 77.6458 413.236L71.9271 408.119C70.4529 406.8 68.1281 407.244 67.2435 409.013L66.3292 410.842C65.821 411.858 64.7822 412.5 63.6459 412.5H56.4065C55.0004 412.5 53.783 411.523 53.478 410.151L52.522 405.849C52.217 404.477 50.9996 403.5 49.5935 403.5H46.3197C45.4788 403.5 44.6765 403.853 44.1082 404.473L40.2885 408.64C39.7814 409.193 39.5 409.916 39.5 410.667V427.684C39.5 428.523 39.1486 429.323 38.5312 429.891L28.1643 439.429C27.4356 440.099 26.4232 440.367 25.4585 440.144L21.8097 439.302C20.9764 439.11 20.1008 439.282 19.4027 439.776Z"
          fill="#B8B8B8"
        />
        <path
          id="Vector 51"
          d="M210.244 445.103L205.744 441.888C203.758 440.47 201 441.889 201 444.33V448.472C201 449.432 201.459 450.334 202.235 450.899L204.894 452.832C205.868 453.54 207.17 453.598 208.202 452.979L210.043 451.874C210.947 451.332 211.5 450.355 211.5 449.301V447.544C211.5 446.575 211.032 445.666 210.244 445.103Z"
          fill="#B8B8B8"
        />
      </g>
      <g id="others">
        <path
          id="Vector 27"
          d="M211.93 218H211C209.895 218 209 218.895 209 220V220.731C209 221.226 209.184 221.703 209.516 222.071L213.986 227.02C214.943 228.08 216.671 227.824 217.28 226.531L217.81 225.404C217.935 225.138 218 224.847 218 224.553V223.803C218 223.083 217.417 222.5 216.697 222.5C216.262 222.5 215.855 222.282 215.613 221.92L213.594 218.891C213.223 218.334 212.598 218 211.93 218Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 28"
          d="M224.696 227.311L224.162 228.735C223.79 229.727 224.255 230.836 225.222 231.265L227.612 232.328C227.868 232.441 228.145 232.5 228.424 232.5H233.839C234.557 232.5 235.22 232.115 235.576 231.492L236.736 229.461C236.909 229.159 237 228.817 237 228.469V226C237 224.895 236.105 224 235 224H231.4C231.136 224 230.875 224.052 230.631 224.154L225.799 226.167C225.289 226.379 224.89 226.793 224.696 227.311Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 30"
          d="M136.042 262.5H135.883C133.957 262.5 132.584 264.368 133.158 266.207L134.159 269.41C134.379 270.112 134.849 270.709 135.479 271.088L138.172 272.703C139.005 273.203 140.029 273.269 140.918 272.879L145.702 270.786C146.794 270.309 147.5 269.23 147.5 268.038V265.864C147.5 265.311 147.28 264.78 146.889 264.389L146.43 263.93C145.703 263.203 144.488 263.353 143.96 264.234C143.675 264.709 143.161 265 142.606 265H140.458C139.553 265 138.715 264.525 138.25 263.75C137.785 262.975 136.947 262.5 136.042 262.5Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 32"
          d="M202.223 207.777L199.794 210.206C199.285 210.715 198.596 211 197.878 211C196.748 211 195.737 210.299 195.341 209.242L194.987 208.298C194.678 207.475 194.746 206.557 195.173 205.788L196.584 203.249C196.856 202.76 197.26 202.356 197.749 202.084L198.264 201.798C199.931 200.872 202.028 201.715 202.589 203.538L202.969 204.774C203.296 205.836 203.009 206.991 202.223 207.777Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 33"
          d="M186.995 198.392L186.094 201.773C185.744 203.086 184.554 204 183.195 204H181.044C180.075 204 179.166 203.532 178.603 202.744L175.757 198.76C175.006 197.709 175.012 196.296 175.772 195.251L178.004 192.182C178.316 191.754 178.814 191.5 179.344 191.5H179.5C180.328 191.5 181 192.172 181 193C181 193.828 181.672 194.5 182.5 194.5H183.961C184.634 194.5 185.286 194.729 185.811 195.149L185.971 195.277C186.9 196.02 187.302 197.242 186.995 198.392Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 41"
          d="M135.698 231.779L140.147 239.937C140.673 240.9 141.683 241.5 142.781 241.5H144.542C145.155 241.5 145.744 241.256 146.178 240.822C146.949 240.051 147.077 238.846 146.484 237.93L142.6 231.928C142.223 231.344 142.144 230.616 142.388 229.965C142.926 228.53 141.865 227 140.333 227H138.478C137.278 227 136.193 227.715 135.721 228.818L135.574 229.161C135.212 230.006 135.257 230.971 135.698 231.779Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 42"
          d="M392.986 233.592L390.213 231.928C389.746 231.648 389.213 231.5 388.669 231.5H382.958C381.877 231.5 381 230.623 381 229.542C381 229.187 381.096 228.839 381.279 228.535L383.753 224.412C383.914 224.143 384 223.832 384 223.517C384 222.184 385.445 221.341 386.597 222.012C386.861 222.165 387.161 222.246 387.466 222.246H388.395C389.398 222.246 390.334 221.746 390.891 220.912L391.877 219.434C392.279 218.832 392.885 218.395 393.583 218.205L396.14 217.507C397.273 217.198 398.482 217.579 399.234 218.481L399.6 218.921C400.17 219.605 401.015 220 401.905 220H402.792C403.258 220 403.717 219.892 404.133 219.683L406.304 218.598C407.037 218.231 407.5 217.482 407.5 216.663C407.5 215.468 408.468 214.5 409.663 214.5H409.75C410.993 214.5 412 215.507 412 216.75V217.849C412 218.59 411.726 219.305 411.23 219.856L408.27 223.144C407.774 223.695 407.5 224.41 407.5 225.151V225.267C407.5 226.339 406.928 227.33 405.999 227.866L396.029 233.618C395.085 234.162 393.921 234.152 392.986 233.592Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 44"
          d="M452.203 151H451C449.343 151 448 152.343 448 154V154.558C448 155.469 448.414 156.331 449.126 156.901L450.683 158.146C451.967 159.173 453.838 158.976 454.879 157.704L457.02 155.087C457.33 154.707 457.5 154.232 457.5 153.742C457.5 152.729 456.785 151.857 455.792 151.658L452.791 151.058C452.598 151.02 452.4 151 452.203 151Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 52"
          d="M512.699 44.1427L523.506 30.8964C525.104 28.9368 523.71 26 521.181 26H515.741C514.664 26 513.67 26.5769 513.136 27.5116L512.864 27.9884C512.33 28.9231 511.336 29.5 510.259 29.5H508.147C507.121 29.5 506.167 30.024 505.616 30.8894L503.884 33.6106C503.333 34.476 502.379 35 501.353 35H498.408C497.816 35 497.237 35.1753 496.744 35.5038L492.256 38.4962C491.763 38.8247 491.184 39 490.592 39H485C483.895 39 483 38.1046 483 37C483 35.3519 481.118 34.4111 479.8 35.4L477.795 36.9038C477.279 37.2908 476.651 37.5 476.006 37.5C475.059 37.5 474.168 37.9501 473.606 38.7127L469.248 44.6275C468.278 45.9446 468.541 47.7964 469.841 48.7902L474.327 52.2206C475.331 52.9884 476.708 53.0446 477.772 52.3611L482.259 49.4765C482.743 49.1654 483.306 49 483.881 49H488.738C489.545 49 490.318 48.675 490.882 48.0983L493.618 45.3036C494.182 44.7269 494.955 44.4019 495.762 44.4019H498.148C498.985 44.4019 499.758 44.8481 500.176 45.5724C500.67 46.4286 501.649 46.882 502.622 46.7051L510.911 45.1979C511.614 45.0702 512.248 44.696 512.699 44.1427Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 53"
          d="M522.737 50H513C511.343 50 510 51.3431 510 53V54L509.836 55.3135C509.645 56.8397 510.639 58.2629 512.138 58.6088L515.061 59.2833C515.672 59.4242 516.311 59.3704 516.889 59.1294L521.446 57.2308C521.812 57.0784 522.204 57 522.6 57H523.023C525.016 57 526.455 55.0923 525.907 53.1758L525.622 52.1758C525.254 50.8879 524.077 50 522.737 50Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 54"
          d="M459.162 52.3785L462.2 50.1C462.719 49.7105 463.351 49.5 464 49.5H465.259C465.925 49.5 466.552 49.8094 466.957 50.3371C467.909 51.5784 467.251 53.3887 465.723 53.7281L465.418 53.7961C464.829 53.9269 464.313 54.2802 463.979 54.7821L463.387 55.6688C462.833 56.5005 461.9 57 460.9 57H460.703C459.941 57 459.218 56.6615 458.73 56.0762C457.789 54.9471 457.986 53.2603 459.162 52.3785Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 55"
          d="M530.255 36.8276L528.594 38.6736C527.786 39.5706 528.423 41 529.63 41C529.872 41 530.111 40.9367 530.321 40.8163L533.242 39.1474C533.414 39.0494 533.594 38.9685 533.782 38.9061L537.16 37.7802C537.708 37.5973 538.192 37.2598 538.553 36.8082L540.967 33.7907C541.514 33.1077 541.333 32.0996 540.583 31.6496C539.963 31.2775 539.163 31.4212 538.711 31.9859L536.401 34.8741C535.831 35.5857 534.969 36 534.058 36H532.113C531.405 36 530.729 36.3008 530.255 36.8276Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 39"
          d="M355.5 110.25V109.01C355.5 108.069 355.02 107.194 354.226 106.69C352.396 105.525 350 106.84 350 109.01V110.25C350 111.769 351.231 113 352.75 113C354.269 113 355.5 111.769 355.5 110.25Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 40"
          d="M389.012 118.132L385.447 116.052C384.889 115.727 384.182 115.818 383.725 116.275C383.292 116.708 383.185 117.369 383.458 117.917L383.953 118.905C384.303 119.606 384.361 120.418 384.113 121.161L383.949 121.654C383.425 123.226 384.274 124.925 385.846 125.449L386.551 125.684C388.494 126.331 390.5 124.885 390.5 122.838V120.723C390.5 119.656 389.933 118.669 389.012 118.132Z"
          fill="#D9D9D9"
        />
        <path
          id="Vector 31"
          d="M237.977 163H243.26C245.179 163 246.605 164.777 246.189 166.651L245.071 171.679C245.024 171.892 245 172.11 245 172.329V177.962C245 178.318 244.937 178.671 244.813 179.004L240.401 190.917C240.143 191.614 240.153 192.382 240.429 193.073L241.619 196.048C241.866 196.665 241.901 197.347 241.718 197.986L240.298 202.958C240.106 203.628 240.173 204.346 240.485 204.969L241.383 206.767C241.896 207.793 241.15 209 240.003 209C239.393 209 238.84 208.641 238.593 208.084L237.792 206.282C237.31 205.198 236.236 204.5 235.05 204.5H234.959C233.529 204.5 232.298 203.491 232.018 202.088L231.661 200.307C231.556 199.779 231.31 199.289 230.95 198.888L227.585 195.15C227.203 194.726 226.95 194.201 226.856 193.637L225.158 183.448C225.055 182.832 224.762 182.262 224.32 181.82L222.621 180.121C221.45 178.95 221.45 177.05 222.621 175.879L228.192 170.308C228.709 169.791 229.411 169.5 230.142 169.5C230.998 169.5 231.806 169.102 232.328 168.424L235.599 164.171C236.167 163.433 237.046 163 237.977 163Z"
          fill="#D9D9D9"
        />
      </g>
      <g id="routes">
        <path
          id="route_shinokayama_tonosho"
          d="M194 44.5H299C304.523 44.5 309 48.9772 309 54.5V158.5C309 164.023 313.477 168.5 319 168.5H369C374.523 168.5 379 172.977 379 178.5V179.5C379 185.023 383.477 189.5 389 189.5H483"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_shinokayama_tonosho")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <path
          id="route_himeji_fukuda"
          d="M811 93L801 87.2265V98.7735L811 93ZM700.5 117.5L700.999 118.366L722.634 105.894L722.135 105.028L721.636 104.162L700.001 116.634L700.5 117.5ZM767.084 93V94H802V93V92H767.084V93ZM722.135 105.028L722.634 105.894C736.152 98.1019 751.481 94 767.084 94V93V92C751.13 92 735.457 96.1941 721.636 104.162L722.135 105.028Z"
          fill="#B8B8B8"
        onClick={() => onRouteClick?.("route_himeji_fukuda")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <g
        id="route_kobe_sakate_takamatsuhigashi"
        onClick={() => onRouteClick?.("route_kobe_sakate_takamatsuhigashi")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      >
          <path
            id="Vector 78"
            d="M811 380.5L801 374.726V386.274L811 380.5ZM326.5 461.5H327.5V440.5H326.5H325.5V461.5H326.5ZM386.5 380.5V381.5H802V380.5V379.5H386.5V380.5ZM326.5 440.5H327.5C327.5 407.915 353.915 381.5 386.5 381.5V380.5V379.5C352.811 379.5 325.5 406.811 325.5 440.5H326.5Z"
            fill="#B8B8B8"
          />
          <path
            id="Vector 79"
            d="M666 249.5V320.5C666 353.637 639.137 380.5 606 380.5H599"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
          <path
            id="Vector 80"
            d="M666 249.5V320.5C666 353.637 692.863 380.5 726 380.5H730.5"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
        </g>
        <g
        id="route_kyobashi_inujima_karato"
        onClick={() => onRouteClick?.("route_kyobashi_inujima_karato")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      >
          <path
            id="Vector 64"
            d="M359 200.5V185.5C359 179.977 363.477 175.5 369 175.5H402.5C408.023 175.5 412.5 171.023 412.5 165.5V106C412.5 100.477 408.023 96 402.5 96H378.5C374.358 96 371 99.3579 371 103.5"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
          <path
            id="Vector 75"
            d="M371 103.5V98.5C371 92.9772 366.523 88.5 361 88.5H301C295.477 88.5 291 84.0228 291 78.5V66.5C291 60.9772 286.523 56.5 281 56.5H204H193.838C190.782 56.5 187.894 55.1029 185.997 52.707L170 32.5"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
        </g>
        <path
          id="route_tonosho_inujima"
          d="M359 103.5C359 100.186 356.314 97.5 353 97.5H338C332.477 97.5 328 101.977 328 107.5V151.5C328 157.023 332.477 161.5 338 161.5H376.5C382.023 161.5 386.5 165.977 386.5 171.5V175.5C386.5 181.023 390.977 185.5 396.5 185.5H483"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_tonosho_inujima")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <path
          id="route_hoden_inujima"
          d="M367 103.5V66.5"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_hoden_inujima")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <path
          id="route_takamatsu_oshima"
          d="M300 461V443C300 404.34 331.34 373 370 373H371.5"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_takamatsu_oshima")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <path
          id="route_tonosho_miyanoura"
          d="M166 267.5C160.477 267.5 156 271.977 156 277.5V295C156 300.523 160.477 305 166 305H195.5H275.508C323.852 305 365.371 269.875 374 222.308C376.589 208.037 389.044 197.5 403.548 197.5H483"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_tonosho_miyanoura")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <path
          id="route_takamatsu_ikeda"
          d="M296 461V419.533C296 400.787 306.486 383.616 323.162 375.054L500.5 284L526.851 268.499C542.123 259.516 551.5 243.121 551.5 225.403V213"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_takamatsu_ikeda")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <path
          id="route_takamatsu_tonosho"
          d="M292 461.5V413.953C292 395.145 302.156 377.803 318.559 368.601L378.09 335.206C388.668 329.272 396.728 319.695 400.77 308.259L433.787 214.836C436.612 206.844 444.167 201.5 452.644 201.5H483"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_takamatsu_tonosho")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <g
        id="route_takamatsu_megijima_ogijima"
        onClick={() => onRouteClick?.("route_takamatsu_megijima_ogijima")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      >
          <path
            id="Vector 67"
            d="M313.5 341V356.834C313.5 359.792 312.191 362.598 309.924 364.498L279.5 390"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
          <path
            id="Vector 56"
            d="M278 461V396.5"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
        </g>
        <g
        id="route_uno_ieura_karato_tonosho"
        onClick={() => onRouteClick?.("route_uno_ieura_karato_tonosho")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      >
          <path
            id="Vector 62"
            d="M132 200.5V204C132 209.523 136.477 214 142 214H246C251.523 214 256 209.523 256 204V198C256 192.477 260.477 188 266 188H290C295.523 188 300 192.477 300 198V202"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
          <path
            id="Vector 63"
            d="M300 202V189C300 183.477 304.477 179 310 179H345C350.523 179 355 183.477 355 189V200"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
          <path
            id="Vector 77"
            d="M355 200.5C355 196.634 358.134 193.5 362 193.5H483"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
        </g>
        <path
          id="route_takamatsu_karato"
          d="M288 461.5V361.5C288 355.977 292.477 351.5 298 351.5H316.5C349.637 351.5 376.5 324.637 376.5 291.5V192.25C376.5 188.522 373.478 185.5 369.75 185.5C366.022 185.5 363 188.522 363 192.25V200"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_takamatsu_karato")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <g
        id="route_takamatsu_honmura_ieura"
        onClick={() => onRouteClick?.("route_takamatsu_honmura_ieura")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      >
          <path
            id="Vector 59"
            d="M284 461V361.5C284 355.977 279.523 351.5 274 351.5H249.5C243.977 351.5 239.5 347.023 239.5 341.5V246C239.5 240.477 235.023 236 229.5 236H217.5C211.977 236 207.5 240.477 207.5 246V251"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
          <path
            id="Vector 60"
            d="M223 236H253.5C259.023 236 263.5 231.523 263.5 226V205C263.5 199.477 267.977 195 273.5 195H285C288.866 195 292 198.134 292 202"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
          <path
            id="Vector 61"
            d="M239.5 255.5V246C239.5 240.477 243.977 236 249.5 236L253.5 236C259.023 236 263.5 231.523 263.5 226V215"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
        </g>
        <g
        id="route_miyanoura_ieura_inujima"
        onClick={() => onRouteClick?.("route_miyanoura_ieura_inujima")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      >
          <path
            id="Vector 71"
            d="M166 255.5H164C158.477 255.5 154 251.023 154 245.5V218.5C154 212.977 158.477 208.5 164 208.5H182.118C185.199 208.5 188.108 207.08 190.003 204.65L222.997 162.35C224.892 159.92 227.801 158.5 230.882 158.5H247C252.523 158.5 257 163.041 257 168.564C257 174.037 261.399 178.556 266.872 178.627L286.128 178.873C291.601 178.944 296 183.4 296 188.873V202.5"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
          <path
            id="Vector 72"
            d="M296 202V104C296 98.4772 300.477 94 306 94H354C358.971 94 363 98.0294 363 103"
            stroke="#B8B8B8"
            strokeWidth={2}
          />
        </g>
        <path
          id="route_uno_honmura"
          d="M128 201.5V210.934C128 216.482 132.518 220.97 138.066 220.933L193.434 220.567C198.982 220.53 203.5 225.018 203.5 230.566V251.5"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_uno_honmura")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <path
          id="route_uno_miyanoura"
          d="M124 201V249.5C124 255.023 128.477 259.5 134 259.5H165.5"
          stroke="#B8B8B8"
          strokeWidth={2}
          strokeLinejoin="round"
        onClick={() => onRouteClick?.("route_uno_miyanoura")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
        <path
          id="route_takamatsu_miyanoura"
          d="M166 263.5H162.066C156.518 263.5 152.03 268.018 152.067 273.566L152.663 363.573C152.882 396.554 179.68 423.175 212.662 423.175H264C269.523 423.175 274 427.652 274 433.175V461"
          stroke="#B8B8B8"
          strokeWidth={2}
        onClick={() => onRouteClick?.("route_takamatsu_miyanoura")}
        className="ferry-route"
        style={{ cursor: 'pointer' }}
      />
      </g>
      <g id="Ports">
        <rect
          id="Takamatsu_port"
          x={269.5}
          y={461}
          width={39}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Takamatsu_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Uno_port"
          x={116.5}
          y={193}
          width={23}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Uno_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Ieura_port"
          x={285.5}
          y={202}
          width={23}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Ieura_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Inujima_port"
          x={353.5}
          y={103.5}
          width={23}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Inujima_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Karato_port"
          x={347.5}
          y={200}
          width={23}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Karato_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
            id="Miyanoura_port"
            x={165}
            y={250.5}
            width={9}
            height={24}
            rx={4}
            fill="white"
            stroke="black"
          onClick={() => onPortClick?.("Miyanoura_port")}
          className="ferry-port"
          style={{ cursor: 'pointer' }}
        />
        <rect
          id="Tonosho_port"
          x={482}
          y={179.5}
          width={9}
          height={28}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Tonosho_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Megijima_port"
          x={273.5}
          y={389}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Megijima_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Oshima_port"
          x={370.5}
          y={369}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Oshima_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Ogijima_port"
          x={309.5}
          y={335}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Ogijima_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Honmura_port"
          x={201.5}
          y={250}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Honmura_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Hoden_port"
          x={362.5}
          y={59}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Hoden_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Ikeda_port"
          x={547.5}
          y={207}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Ikeda_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Sakate_port"
          x={662.5}
          y={242}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Sakate_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Fukuda_port"
          x={693.5}
          y={115}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Fukuda_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Shinokayama_port"
          x={186.5}
          y={40}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Shinokayama_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Kyobashi_port"
          x={164.5}
          y={25}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Kyobashi_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
        <rect
          id="Takamatsu_Higashi_port"
          x={322.5}
          y={461}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Takamatsu_Higashi_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
      <rect
          id="Kobe_port"
          x={816}
          y={376}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Kobe_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
      <rect
          id="Himeji_port"
          x={816}
          y={96}
          width={8}
          height={8}
          rx={4}
          fill="white"
          stroke="black"
        onClick={() => onPortClick?.("Himeji_port")}
        className="ferry-port"
        style={{ cursor: 'pointer' }}
      />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_0_1">
        <rect width={850} height={540} fill="white" />
      </clipPath>
    </defs>
      {children}
      </g>
    </svg>
));
export default SvgMapArtwork;

export { SvgMapArtwork as MapArtwork };


// Port data extracted for labels (auto-generated)
export const mapPorts: Array<{
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  en: string;
  zh: string;
  ja: string;
  labelOffset?: { x: number; y: number };
}> = mapConfig.ports.map(port => ({
  id: port.id,
  x: port.svgRect.x,
  y: port.svgRect.y,
  width: port.svgRect.width,
  height: port.svgRect.height,
  en: port.name.en,
  zh: port.name.zh,
  ja: port.name.ja,
  labelOffset: port.labelOffset
}));
